//@flow
import _ from 'lodash';

class ChartUtils {
    static getPiePercentage(
        data: ?$ReadOnlyArray<{ value: number }>,
        payload: ?{ value: number }
    ): ?number {
        if (data && payload) {
            const total = _.sumBy(data, 'value');
            return (payload.value / total) * 100;
        }
        return null;
    }
}

export default ChartUtils;
